// extracted by mini-css-extract-plugin
export default {"introductionContainer":"sales-methods-sales-methods-page_introductionContainer"};